import { useFiltersLength } from "../hooks/useFiltersLength";
import {
  type FilterState,
  type FilterValue,
  type TableFilterId,
  type TableFiltersConfig,
} from "../types";

import { FiltersOverflowSideDrawer } from "./FiltersOverflowSideDrawer";
import { RenderFilter } from "./RenderFilter";

type Props = {
  config: TableFiltersConfig;
  filterState: FilterState;
  isLoading: boolean;
  onFilterChange: (filterId: string, value: FilterValue) => void;
  onResetFilters: () => void;
  showLabel?: boolean;
  tableId: TableFilterId;
  disabled?: boolean;
};

export function RenderFilters({
  config,
  filterState,
  isLoading,
  onFilterChange,
  onResetFilters,
  showLabel,
  tableId,
  disabled = false,
}: Props) {
  const filtersLength = useFiltersLength({
    maxShownFilters: config.maxShownFilters,
  });
  const originalFilters = config.filters.filter(
    (filter) => filter.isVisible !== false,
  );
  const originalVisibleFiltersLength = originalFilters.filter(
    (filter) => !filter.hideFromModal,
  ).length;
  const filters = originalFilters.slice(0, filtersLength);
  const visibleFiltersLength = filters.filter(
    (filter) => !filter.hideFromModal,
  ).length;

  return (
    <>
      {filters.map((filter) => (
        <RenderFilter
          disabled={disabled}
          filter={filter}
          filterState={filterState}
          isLoading={isLoading}
          key={filter.id}
          onFilterChange={onFilterChange}
          showLabel={showLabel}
          tableId={tableId}
          type={filter.type}
        />
      ))}
      {originalVisibleFiltersLength > visibleFiltersLength ? (
        <FiltersOverflowSideDrawer
          disabled={disabled}
          filterState={filterState}
          isLoading={isLoading}
          onFilterChange={onFilterChange}
          onResetFilters={onResetFilters}
          originalFilters={originalFilters}
          tableId={tableId}
        />
      ) : null}
    </>
  );
}
